import React, { useEffect, useState, useRef } from 'react';
import ChatHistoryList from './ChatHistoryList';
import styled from 'styled-components';
import HeaderWithBack from '../../../components/HeaderWithBack';
import BottomNav from '../../../components/BottomNav';
import { useLocation } from 'react-router-dom';
import axios from '../../../api/axios';
import { useAuth } from '../../../contexts/AuthContext';
import { useAuthStore } from '../../../stores/authStores';

const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  overflow: hidden;
`;

const MessagesContainer = styled.div`
  flex: 1;
  padding: 0 16px 10px; 
  overflow-y: auto;
  background-color: #ffffff;
`;

interface ChatProps {
  userId: string | null;
  username: string | null;
  conversationID: string;  
  conversationType: number; 
}

const ChatHistories: React.FC<ChatProps> = ({ userId, username, conversationID, conversationType }) => {
  const location = useLocation();
  const profileName = location.state?.profileName || null; 
  const messagesEndRef = useRef<HTMLDivElement | null>(null); 
  const messagesContainerRef = useRef<HTMLDivElement | null>(null); 

  const [teleconsult, setTeleconsult] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState<boolean>(true);
  const authToken = useAuthStore((state) => state.token);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`list-chat-histories`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          }
        });

        const data = Array.isArray(response.data) ? response.data : response.data.data || [];
        setTeleconsult(data);

      } catch (error) {
        console.error('Error fetching data:', error);
        setTeleconsult([]);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData(); 
  }, [authToken]);

  return (
    <div
        style={{
            fontFamily: "Arial, sans-serif",
            minHeight: "100vh",
            paddingBottom: "60px",
        }}
        >
        
      <HeaderWithBack title="Chat Histories" />
        <ChatContainer>
          <MessagesContainer
            ref={messagesContainerRef}
          >
            <ChatHistoryList 
              userId={userId}
              username={username}
              conversationID={conversationID}
              conversationType={conversationType}
              profileName={profileName}
              teleconsults={teleconsult}
            />
            <div ref={messagesEndRef} /> 
          </MessagesContainer>
        </ChatContainer>
      <BottomNav/>
    </div>
  );
};

export default ChatHistories;